import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './TableCell.module.scss';
import { TableCellProps } from './TableCell.types';

export const TableCell = forwardRef<HTMLDivElement, TableCellProps>(
  ({ className, tdClassName, children, align, pinned, pinDistance, style, ...props }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.container, tdClassName, pinned && styles[pinned])}
      style={{
        ...style,
        // @ts-expect-error ---
        ['--pin-distance']: (pinDistance ?? 0) + 'px',
      }}
      data-role="td"
      {...props}
    >
      <div className={styles.content}>
        <div className={classnames(styles.innerContent, align && styles[align], className)}>
          {children}
        </div>
      </div>
    </div>
  )
);
